// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClusterEntity } from './ClusterEntity';
import {
  ClusterEntityFromJSON,
  ClusterEntityFromJSONTyped,
  ClusterEntityToJSON,
  ClusterEntityToJSONTyped,
} from './ClusterEntity';

/**
 *
 * @export
 * @interface ClusterList
 */
export interface ClusterList {
  /**
   *
   * @type {Array<ClusterEntity>}
   * @memberof ClusterList
   */
  items?: Array<ClusterEntity>;
}

/**
 * Check if a given object implements the ClusterList interface.
 */
export function instanceOfClusterList(value: object): value is ClusterList {
  return true;
}

export function ClusterListFromJSON(json: any): ClusterList {
  return ClusterListFromJSONTyped(json, false);
}

export function ClusterListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClusterList {
  if (json == null) {
    return json;
  }
  return {
    items:
      json['items'] == null
        ? undefined
        : (json['items'] as Array<any>).map(ClusterEntityFromJSON),
  };
}

export function ClusterListToJSON(json: any): ClusterList {
  return ClusterListToJSONTyped(json, false);
}

export function ClusterListToJSONTyped(
  value?: ClusterList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    items:
      value['items'] == null
        ? undefined
        : (value['items'] as Array<any>).map(ClusterEntityToJSON),
  };
}
